
const extraPercentage = 0.1;
const minExtraDots = 4;
const getAxisMaxValue = (dataLength: number): number => {
  const coefficient = dataLength * extraPercentage;
  return coefficient > minExtraDots ? dataLength + coefficient : dataLength + minExtraDots;
}

export default getAxisMaxValue;